<template>
  <div
    class="flex-none bg-bottom bg-no-repeat bg-cover"
    :style="{ backgroundImage: 'url(' + require('@assets/images/bg-intro.png') + ')' }"
  >
    <div class="w-8/12 py-10 mx-auto sm:w-1/2 v:py-32 sm:py-20">
      <BaseImg src="/logos/logo-white-2.svg" class="w-full mx-auto sm:w-80" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'KioskBanner',
}
</script>
